class EfTabs {
    static get $inject() {
        return ['$scope']
    }

    constructor($scope) {
        this.activeTab = null
        this.tabs = []
        this.history = []

        $scope.$watch(() => this.activeTab, (id) => {
            if (id && this.history[this.history.length - 1] !== id) {
                this.history.push(id)
            }
        })
    }

    selectTab(id) {
        this.activeTab = id
    }

    addTab(tab) {
        this.tabs = [...this.tabs, tab]

        if (this.tabs.length == 1)
            this.activeTab = this.tabs[0].id
    }

    removeTab(removed) {
        this.tabs = this.tabs.filter(tab => tab.id !== removed.id)
        this.history = this.history.filter(id => id !== removed.id)

        if (this.activeTab === removed.id) {
            this.activeTab = this.history.pop()
        }
    }

    getActiveTab() {
        return this.activeTab
    }
}

angular.module('eficienciaFiscalModule')
    .component('efTabs', {
        controller: EfTabs,
        transclude: 'true',
        bindings: {
            activeTab: '=?active'
        },
        template: `
        <div>
            <ul class="nav nav-tabs bordered" style="border-right: 0; border-top: 0; border-left: 0">
                <li ng-repeat="tab in $ctrl.tabs" ng-hide="!tab.label" ng-class="{active: $ctrl.activeTab == tab.id}" tab-id="{{tab.id}}">
                    <a href="javascript:void(0)" ng-click="$ctrl.selectTab(tab.id)"
                       ng-style="{'padding-right': tab.hasClose ? '34px' : null}">
                        <i class="fa {{tab.icon}}" ng-if="tab.icon"></i> {{tab.label}}
                    </a>
                    <span ng-if="tab.hasClose" ng-click="tab.onClose()" class="air air-top-right" style="top:9px; right:7px;">
                        <button class="btn btn-xs font-xs btn-default hover-transparent">
                            <i class="fa fa-times"></i>
                        </button>
                    </span>
                </li>
            </ul>
            <div class="tab-content" style="padding: 13px;" ng-transclude></div>
        </div>
    `
    })

class EfTabsTab {
    static get $inject() {
        return ['$attrs']
    }

    constructor(attrs) {
        this.hasClose = !!attrs.onClose
    }

    $onInit() {
        this.tabsCtrl.addTab(this)
    }

    $onDestroy() {
        this.tabsCtrl.removeTab(this)
    }

    get active() {
        return this.tabsCtrl.getActiveTab() === this.id
    }
}

angular.module('eficienciaFiscalModule').component('efTabsTab', {
    controller: EfTabsTab,
    require: {
        tabsCtrl: '^efTabs'
    },
    bindings: {
        id: '@',
        label: '@',
        icon: '@',
        onClose: '&'
    },
    transclude: 'true',
    template: `
    <div class="tab-pane active" ng-show="$ctrl.active" ng-transclude></div>
    `
})
